import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import { odata } from "../Filters/Helper";
import { ColumnHelper } from "util/TableHelper";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  notification,
  Select,
  Tooltip,
  Popconfirm,
  Tabs,
  Form,
} from "antd";
import {
  BarsOutlined,
  SendOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import ErpPosTransactionTableFilter from "../Filters/ErpPosTransactionTableFilter";
import { useMediaQuery } from "react-responsive";

function ErpPosTransaction() {
  const isBigScreen = useMediaQuery({
    query: "(min-device-width: 1824px)",
  });

  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });

  const [firm, setFirm] = useState([]);

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      RequestHandler.get(
        `/Firm?$select=id,name,firmBranchNumber,firmClassId,firmClassName&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        if (res.value) {
          setFirm(res.value);
        }
      });
    } else {
      setFirm([]);
    }
  };

  const [order, setOrder] = useState("");
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    activeTab: "0",
    filter: "",
  });

  const getFilterQuery = () => {
    const { filter, activeTab } = tableDataQueryOptions;

    const conditions = [];
    let query = "";

    if (activeTab !== "-1") {
      conditions.push(`erpTransferStatusId Eq ${activeTab}`);
    }

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = "&$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [form] = Form.useForm();

  const [tabKeyValue, setTabKeyValue] = useState();

  const isExportAvailable =
    tableDataQueryOptions.activeTab === "0" ||
    tableDataQueryOptions.activeTab === "3";

  useEffect(() => getTableData(), [order, tableDataQueryOptions]);

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take } = tableDataQueryOptions;

    RequestHandler.get(
      `/ErpPosCollectionTransaction?$count=true${getFilterQuery()}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      }
    });
  };

  const getColumns = () => [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      width: 100,
      align: "center",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "İşlem Tarihi",
      dataIndex: "transactionDate",
      key: "transactionDate",
      sorter: true,
      align: "center",
      render: (data) => moment(data).format("DD.MM.YYYY HH:mm"),
    },
    {
      title: "İşlem Tutarı",
      dataIndex: "amount",
      key: "amount",
      sorter: true,
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Para Birimi",
      dataIndex: "currency",
    },
    {
      title: "İşlemi Yapan",
      dataIndex: "addUserName",
      align: "center",
    },
    {
      title: "Taksit Sayısı",
      dataIndex: "installmentCount",
      align: "center",
    },
    {
      title: "Onay Kodu",
      dataIndex: "authCode",
      align: "center",
    },
    {
      title: "Evrak No",
      dataIndex: "documentNumber",
      align: "center",
    },
    {
      title: "Cari",
      dataIndex: "firmId",
      width: "15%",
      render: (data, row, index) => (
        <Select
          allowClear
          showSearch
          placeholder="En az 2 harf giriniz.."
          defaultValue={data ?? undefined}
          disabled={!isExportAvailable}
          style={{ width: "100%" }}
          dropdownStyle={{ minWidth: "50%" }}
          onSearch={onFirmSearch}
          onChange={(value, option) => {
            let rows = [...tableData.data];
            let rowToUpdate = {
              ...row,
              firmId: value,
              firmName: option?.firmName,
              firmClassId: option?.firmClassId,
              firmClassName: option?.firmClassName,
              firmBranchNumber: option?.firmBranchNumber,
              chequeNumbers: [],
              chequeNumber: option?.chequeNumber,
            };
            rows[index] = rowToUpdate;
            setTableData({ ...tableData, data: rows });
          }}
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
        >
          {data && (
            <Select.Option
              key={row.firmId}
              value={row.firmId}
              firmName={row.firmName}
              firmClassId={row.firmClassId}
              firmBranchNumber={row.firmBranchNumber}
              firmClassName={row.firmClassName}
            >
              {row.firmBranchNumber
                ? `${row.firmName} (${row.firmBranchNumber})`
                : row.firmName}
            </Select.Option>
          )}
          {firm
            .filter((item) => item.id != data)
            .map((item) => (
              <Select.Option
                key={item.id}
                value={item.id}
                firmName={item.name}
                firmClassId={item.firmClassId}
                firmBranchNumber={item.firmBranchNumber}
                firmClassName={item.firmClassName}
              >
                {item.firmBranchNumber
                  ? `${item.name} (${item.firmBranchNumber})`
                  : item.name}
              </Select.Option>
            ))}
        </Select>
      ),
    },
    {
      title: "Durum",
      dataIndex: "erpTransferStatusId",
      align: "center",
      render: (i, row) => {
        const icon = {
          0: {
            component: <InfoCircleOutlined />,
          },
          1: {
            color: "green",
            component: <CheckCircleOutlined />,
          },
          2: {
            color: "orange",
            component: <ClockCircleOutlined />,
          },
          3: {
            color: "red",
            component: <CloseCircleOutlined />,
          },
        };
        let erpStatusText = row.erpTransferStatus;
        if (erpStatusText === "Successful") {
          erpStatusText = "Başarılı";
        } else if (erpStatusText === "Transferring") {
          erpStatusText = "Aktarılıyor";
        } else if (erpStatusText === "Unsuccessful") {
          erpStatusText = "Başarısız";
        } else if (erpStatusText === "NotTransferred") {
          erpStatusText = "Aktarılmadı";
        }

        return (
          <Tooltip
            title={
              erpStatusText === "Başarısız" ? row.errorMessage : erpStatusText
            }
          >
            {icon[i] && (
              <a style={{ fontSize: "130%", color: icon[i].color }}>
                {icon[i].component}
              </a>
            )}
          </Tooltip>
        );
      },
    },
  ];
  const columns = getColumns();

  const paging = (p, filters, sorter) => {
    let order = "";
    if (sorter.columnKey && sorter.order) {
      order =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(order);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onTableSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };

  const onConfirmSuccessfulExport = () => {
    let isSuccess = true;
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    if (isSuccess) {
      selectedRowsData.map((item) => {
        if (item.firmClassId === null) {
          item.firmClassId = "00000000-0000-0000-0000-000000000000";
        }
        if (item.firmId === null) {
          item.firmId = "00000000-0000-0000-0000-000000000000";
        }
      });
      RequestHandler.post(
        "/ErpPosCollectionTransaction/SetSuccessfulTransfer",
        selectedRowsData
      ).then((response) => {
        if (response.success) {
          getTableData();
        }
      });
    }
  };

  const onConfirmNotTransferredExport = () => {
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );
    RequestHandler.post(
      "/ErpPosCollectionTransaction/SetNotTransferredTransfer",
      selectedRowsData
    ).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const onConfirmExport = () => {
    let isSuccess = true;
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );
    // firmBranchNumber valuesu olmayan bir firm seçili ise
    if (selectedRowsData.some((row) => !row.firmBranchNumber)) {
      notification.error({
        message:
          "Seçili POS Tahsilatları içerisinde 'Cari Kodu' olmayan Cari kayıtları var.",
        duration: 3,
      });
      isSuccess = false;
    }

    // valuesu olmayan bir tenant account hareketi seçili ise
    if (selectedRowsData.some((row) => !row.erpCode)) {
      notification.error({
        message:
          "Seçili POS Tahsilatları içerisinde 'Erp Kodu' olmayan Hesaba ait kayıtlar var.",
        duration: 3,
      });
      isSuccess = false;
    }

    if (isSuccess) {
      RequestHandler.post(
        "/ErpPosCollectionTransaction",
        selectedRowsData
      ).then((response) => {
        if (response.success) {
          getTableData();
        } else {
          isSuccess = false;
        }
      });
    }
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
      };
    });
  };

  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });

    setTabKeyValue(tabKey);
  };

  return (
    <>
      <Row>
        <Col xs={24} md={8} lg={16} xl={isBigScreen ? 16 : 15}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> POS TAHSİLAT AKTARIM
          </p>
        </Col>
        <Col
          xs={tableDataQueryOptions.activeTab === "1" ? 24 : 24}
          md={tableDataQueryOptions.activeTab === "1" ? 24 : 8}
          lg={tableDataQueryOptions.activeTab === "1" ? 6 : 4}
          xl={tableDataQueryOptions.activeTab === "1" ? 8 : 6}
          style={{
            textAlign: "right",
            paddingLeft: "0px",
          }}
        >
          <Popconfirm
            title={
              tableDataQueryOptions.activeTab === "0" ||
              tableDataQueryOptions.activeTab === "3"
                ? "Aktarıldı olarak işaretlensin mi?"
                : "Aktarılmadı olarak işaretlensin mi?"
            }
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={
              tableDataQueryOptions.activeTab === "0" ||
              tableDataQueryOptions.activeTab === "3"
                ? onConfirmSuccessfulExport
                : onConfirmNotTransferredExport
            }
            style={{ color: "seagreen" }}
          >
            {(tableDataQueryOptions.activeTab === "0" ||
              tableDataQueryOptions.activeTab === "1" ||
              tableDataQueryOptions.activeTab === "3") && (
              <Button
                type="primary"
                disabled={selectedRowKeys.length < 1}
                style={{ marginBottom: 0 }}
              >
                <SendOutlined />{" "}
                {(tableDataQueryOptions.activeTab === "0" ||
                  tableDataQueryOptions.activeTab === "3") &&
                  "Aktarıldı Yap"}
                {tableDataQueryOptions.activeTab === "1" && "Aktarılmadı Yap"}
              </Button>
            )}
          </Popconfirm>
        </Col>
        <Col
          xs={24}
          md={8}
          lg={4}
          xl={2}
          style={{ textAlign: "right" }}
          hidden={tableDataQueryOptions.activeTab === "1"}
        >
          <Popconfirm
            title="Aktarmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmExport}
          >
            {isExportAvailable && (
              <Button
                type="primary"
                disabled={selectedRowKeys.length < 1}
                style={{ marginBottom: 0 }}
              >
                <SendOutlined /> Erp'ye Aktar
              </Button>
            )}
          </Popconfirm>
        </Col>
      </Row>

      <ErpPosTransactionTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      ></ErpPosTransactionTableFilter>

      <Tabs
        defaultActiveKey={tableDataQueryOptions.activeTab}
        onChange={onTabChange}
      >
        <Tabs.TabPane tab="Tümü" key="-1" />
        <Tabs.TabPane tab="Aktarılmadı" key="0" />
        <Tabs.TabPane tab="Başarılı" key="1" />
        <Tabs.TabPane tab="Aktarılıyor" key="2" />
        <Tabs.TabPane tab="Başarısız" key="3" />
      </Tabs>

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            rowSelection={
              isExportAvailable
                ? {
                    selectedRowKeys: selectedRowKeys,
                    onChange: onTableSelectChange,
                  }
                : tableDataQueryOptions.activeTab === "1"
                ? {
                    selectedRowKeys: selectedRowKeys,
                    onChange: onTableSelectChange,
                  }
                : undefined
            }
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
}

export default ErpPosTransaction;
